// extracted by mini-css-extract-plugin
export default {"btn":"vip_btn__fuE4H","box":"vip_box__Wd2WG","handler":"vip_handler__yaQcu","over":"vip_over__9-gBv"};